// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"translation-sound-button_buttonWrapper__zVCLT","buttonStyles":"translation-sound-button_buttonStyles__qjpSs"};